import React, { useState } from 'react';

import { DefaultFilledButton, PrimaryButton, ResponsiveButtonGroup } from '@magoosh/lib/button';
import Multistep from '@magoosh/lib/multistep';

import AudioOutputConfig from '../../audio_output_config';
import MicrophoneConfig from '../../microphone_config';
import TestRecording from './test_recording';

interface Props {
  onClose: () => void;
  onFinished: () => void;
}

export default (props: Props) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [testRecordingStatus, setTestRecordingStatus] = useState<string>(null);
  const [stepCompletions, setStepCompletions] = useState<boolean[]>(
    [false, false, false]
  );

  const completeCurrentStep = () => {
    if (finalStep()) {
      localStorage.setItem('audioSetupFinished', Date.now().toString());
      props.onFinished();
      return;
    }

    const updatedStepCompletions = [...stepCompletions];
    updatedStepCompletions[currentStep - 1] = true;
    setStepCompletions(updatedStepCompletions);
    setCurrentStep(currentStep + 1);
  };

  const finalStep = () => {
    return currentStep === 3;
  };

  return (
    <div className="d-flex flex-column gap-m">
      <Multistep currentStep={currentStep}>
        <Multistep.StepIndicators
          colorPalette={{ dark: '#1D9F6B', light: '#DDF1E9' }}
          navigate={setCurrentStep}
        />

        <Multistep.Step complete={stepCompletions[0]} navigable>
          <div className="d-flex flex-column gap-s">
            <h4 className="u-margin-A-n">
              <strong>Audio Playback</strong>
            </h4>

            <AudioOutputConfig />
          </div>
        </Multistep.Step>

        <Multistep.Step complete={stepCompletions[1]} navigable>
          <div className="d-flex flex-column gap-s">
            <h4 className="u-margin-A-n">
              <strong>Microphone Input</strong>
            </h4>

            <MicrophoneConfig />
          </div>
        </Multistep.Step>

        <Multistep.Step complete={stepCompletions[2]} navigable>
          <div className="d-flex flex-column gap-s">
            <h4 className="u-margin-A-n">
              <strong>Test Your Setup</strong>
            </h4>

            <div>
              Start recording and say: "I will work hard and reach my target score."
            </div>

            <TestRecording              
              onError={() => setTestRecordingStatus('error')}
              onFinish={completeCurrentStep}
              onRetry={() => setTestRecordingStatus(null)}
              onSuccess={() => setTestRecordingStatus('success')}
            />
          </div>
        </Multistep.Step>
      </Multistep>

      <ResponsiveButtonGroup>
        {
          finalStep() && testRecordingStatus === 'error' ? (
            <DefaultFilledButton
              onClick={() => {
                setTestRecordingStatus(null);
                setCurrentStep(2);
              }}>
              Try Again
            </DefaultFilledButton>
          ) : (
            <PrimaryButton
              disabled={finalStep() && !testRecordingStatus}
              onClick={completeCurrentStep}
            >
              {finalStep() ? 'Finish' : 'Save and Continue'}
            </PrimaryButton>
          )
        }
        
        <DefaultFilledButton onClick={props.onClose}>
          Cancel
        </DefaultFilledButton>
      </ResponsiveButtonGroup>
    </div>
  );
};
